import { useCallback } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import { feSetStylistId, feSidebarClose } from 'actions/ui.actions';
import ICON_HEADER from 'assets/images/icons/calendar-purple-light.svg';
import ExternalLink from 'components/generic/ExternalLink.component';
import S from 'constants/string.const';
import useIsFromMobileApp from 'hooks/useIsFromMobileApp.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import { formatSegmentWeek } from 'utils/date/format.util';
import { nowAsTimestamp } from 'utils/date/now.util';
import linkToCalendar from 'utils/links/linkToCalendar';

import PadLock from 'lib/components/PadLock';

import CN from './TopNav.module.scss';

const LINK_HELP = 'https://help.getslick.com';

const TopNav = ({ title, children, feSidebarClose, feSetStylistId }) => {
  const salonId = useCurrentSalonId();
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const isFromMobile = useIsFromMobileApp();

  const componentClasses = cn({
    [CN.component]: true,
    [CN.dark]: isDarkMode,
  });

  const linkCalendar = linkToCalendar({ salonId, week: formatSegmentWeek(nowAsTimestamp()) }) || S.hash;

  const handleCalendarClick = useCallback(() => {
    feSetStylistId(null);
    feSidebarClose({ tag: 'TopNav.handleCalendarClick()' });
  }, [feSetStylistId, feSidebarClose]);

  return (
    <div className={componentClasses}>
      <div>
        {children}
        <div className={CN.title}>{title}</div>
      </div>

      <div className={CN.controls}>
        {!isFromMobile && (
          <>
            <div className={CN.control}>
              <ExternalLink link={LINK_HELP} variant="inline">
                <div className={CN.helpIcon}>{t('common.help')}</div>
              </ExternalLink>
            </div>

            <div className={cn([CN.control], [CN.background])}>
              <NavLink to={linkCalendar} onClick={handleCalendarClick} className={CN.calendarLink}>
                <img src={ICON_HEADER} alt="" className={CN.calendarIcon} />
              </NavLink>
            </div>
          </>
        )}
        <div className={CN.control}>
          <PadLock />
        </div>
      </div>
    </div>
  );
};

const TopNavHoc = connect(
  null,
  mapActionsToDispatchToProps({
    feSidebarClose,
    feSetStylistId,
  }),
)(TopNav);

export default TopNavHoc;
